<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('onfido requests')"
      :columns="columns"
      :column_search="false"
      resource_url="/onfido/request/datatables"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="$router.push({ path: '/onfido/settings' })"
        >
          <span class="icon"><i class="fa fa-users"></i></span>
          <span>{{ $t("profiles") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
    <onfido-request-modal ref="onfido_request_modal" @success="refresh" />
    <log-modal ref="log_modal" />
    <detail-modal ref="detail_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
} from "@/utils";
import OnfidoRequestModal from "../onfido_request_modal/Index.vue";
import LogModal from "../log_modal/Index.vue";
import DetailModal from "../detail_modal/Index.vue";
import { truncate } from "lodash";

export default {
  name: "OnfidoRequestsDatatable",
  components: { GenericTable, OnfidoRequestModal, LogModal, DetailModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          data: (row) => {
            return format_date_time(row.create_date);
          },
        },
        {
          title: v.$t("applicant"),
          searchable: false,
          data: (row) => {
            return `<div class="title is-6">${
              row.applicant_request?.first_name
            } ${row.applicant_request?.last_name}</div>
            <div class="subtitle is-7">${row.check_request?.report_names
              ?.map((n) => v.$t(n))
              .join(", ")}</div>`;
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          data: (row) => {
            return v.$t(row.status);
          },
        },
        {
          title: v.$t("result"),
          searchable: false,
          data: (row) => {
            return `${
              row.check_response?.status ? v.$t(row.check_response?.status) : ""
            } -  ${row.check_response?.result || ""}`;
          },
        },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   data: (row) => {
        //     return JSON.stringify(row, null, 2);
        //   },
        // },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("log"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.log_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.detail_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete request?"),
                    v,
                    () => {
                      del("/onfido/request", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    // format_date_time,
    create() {
      let v = this;
      v.$refs.onfido_request_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    translate_status(status) {
      let v = this;
      switch (status) {
        case "C":
          return v.$t("created");
        case "P":
          return v.$t("processed");
        case "E":
          return v.$t("errored");
        default:
          return status;
      }
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
